import React, { useState } from 'react'

import {
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    PopoverFooter,
    Button,
    useDisclosure,
    Stack,
    useColorModeValue
} from '@chakra-ui/react'

import theme from '../../../../../Config/theme'

import { FaAngleDown } from 'react-icons/fa'

const DesktopFilterButton = ({ label, content, onClick }) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const buttonBgColor = useColorModeValue('gray.100', 'gray.800')

    return (
        <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
            <PopoverTrigger>
                <Button
                    _focus={{}}
                    _active={{}}
                    _hover={{}}
                    bgColor={buttonBgColor}
                    variant={'outline'}
                    borderRadius={'full'}
                    rightIcon={<FaAngleDown />}
                    onClick={onOpen}
                    fontSize={'lg'}
                >
                    {label}
                </Button>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverBody>
                    {content}
                </PopoverBody>
                <PopoverFooter>
                    <Stack direction={'column'}>
                        <Button
                            _hover={{}}
                            _active={{}}
                            _focus={{}}
                            color={theme.default.defaultColor}
                            background={'transparent'}
                            fontWeight={'700'}
                            onClick={onClick}
                        >
                            Done
                        </Button>
                    </Stack>
                </PopoverFooter>
            </PopoverContent>
        </Popover>
    )
}

export default DesktopFilterButton